
export const ServiceDictionary = {
  auth: 'OneID',
  assessment: 'Ассесмент',
};
